import { makeStyles } from '@mui/styles'

const useOrganizationDetailsStyles = makeStyles((theme) => ({
  root: {
    padding: '10px',
    '& .textfield': {
      marginBottom: '10px',
    },
    '& .mb_20': {
      marginBottom: '20px',
    },
  },
}))

export default useOrganizationDetailsStyles
